import axios from 'axios';
import { apiBaseUrl, localhostKey, pageRoute } from './common';

// Create an Axios instance
const apiClient = axios.create({
  baseURL: apiBaseUrl, 
});

// Add a request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(localhostKey.token); 

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response; 
  },
  (error) => {
    if (error.response && (error.response.status === 403 || error.response.status === 401)) {
      localStorage.removeItem(localhostKey.token);
      window.location.href = pageRoute.login; 
    }
    return Promise.reject(error); 
  }
);

export default apiClient;
